<template>
  <div class="lms-wrapper-two" >

    <student-nav :obj.sync="statObj"></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />

      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <ul class="nav nav-line nav-line-profile mg-b-10">
          <li class="nav-item" v-for="(type, i) in types" :key="'tt' + i">
            <a
              @click="
                clearFilter();
                init();
              "
              v-if="$route.params.cid == type.id"
              class="nav-link d-flex align-items-center active"
              role="button"
            >
              {{ type.label }}
            </a>
            <router-link
              v-else
              :to="{ name: $route.name, params: { cid: type.id } }"
              :class="`nav-link d-flex align-items-center ${
                $route.params.cid == type.id ? 'active' : ''
              }`"
            >
              {{ type.label }}</router-link
            >
          </li>
        </ul>

        <div class="row">
          <div class="col-lg-8 col-xl-9">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.content}px; position: relative; `"
            >
              <template v-if="canView">
                <div class="row row-sm mg-b-25">
                  <template v-if="tasks.length > 0">
                    <div
                      v-for="(task, i) in tasks"
                      :key="'tsk_' + i"
                      class="col-md-4"
                    >
                      <div class="card card-event" @click="taskDetail(task.id, task.budget)">
                        <img
                          style="height: 320px"
                          :src="`${task.secondAttachmentUrl}?w=480`"
                          class="card-img-top"
                          alt
                        />
                        <div
                          :title="task.task"
                          class="card-body tx-13"
                          style="min-height: 120px"
                        >
                          <h5 :title="task.task">
                            <span :title="task.task">{{ task.task }}</span>
                          </h5>
                          <!-- <p class="mg-b-0">Mar 22 - Mar 24, World Trade Center Metro</p>
                          <span class="tx-12 tx-color-03">Manila, Philippines</span>-->
                        </div>
                        <div class="card-footer tx-13">
                          <!-- <span class="tx-color-03">6,187 people interested</span> -->
                          <button class="btn btn-xs btn-secondary">
                            дэлгэрэнгүй
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- <ul class="list-group list-group-flush tx-13">
                      <li
                        v-for="(task, i) in tasks"
                        :key="'tsk_' + i"
                        class="list-group-item d-flex pd-sm-x-20"
                        role="button"
                        @click="taskDetail(task.id, task.budget)"
                      >
                        <div class="avatar" style="min-width: 40px">
                          <span
                            :class="`avatar-initial rounded-circle bg-${
                              colors[(task.id + '')[(task.id + '').length - 1]]
                            }`"
                            >{{ task.task[0] }}</span
                          >
                        </div>
                        <div class="pd-l-10">
                          <p class="tx-medium mg-b-0">{{ task.task }}</p>
                          <small class="tx-12 tx-color-03 mg-b-0">{{
                            task.dueStartDate | moment("YYYY")
                          }}</small>
                        </div>
                        <div class="mg-l-auto text-right">
                          <p class="tx-medium mg-b-2">
                            Үнэ: {{ task.budget }}₮
                          </p>
                          <small
                            class="tx-12 tx-success mg-b-0"
                            v-show="task.im != null"
                            >худалдаж авсан</small
                          >
                        </div>
                      </li>
                    </ul> -->
                  </template>
                  <template v-else>
                    <div class="wd-100p">
                      <ul class="list-group list-group-flush tx-13">
                        <li class="list-group-item d-flex pd-sm-x-20">
                          <div
                            class="
                              container
                              d-flex
                              justify-content-center
                              ht-100p
                            "
                          >
                            <div
                              class="
                                mx-wd-300
                                wd-sm-450
                                ht-100p
                                d-flex
                                flex-column
                                align-items-center
                                justify-content-center
                                pd-t-100
                              "
                            >
                              <div class="wd-80p wd-sm-300 mg-b-15">
                                <img
                                  src="assets/svg/boxempty.svg"
                                  alt
                                  class="img-fluid"
                                />
                              </div>
                              <h4 class="tx-18 text-muted">
                                Мэдээлэл хоосон байна.
                              </h4>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="align-center">
                  <div class="vertical-middle">
                    <div class="alert alert-warning mg-b-0" role="alert">
                      <h6 class="alert-heading">Хандах эрх хүрэхгүй байна!</h6>
                      <hr />
                      <p class="mb-0">
                        Таны нийт оноо
                        <template v-if="point.pointOptions != undefined">{{
                          point.pointOptions.reduce(
                            (sum, st) => sum + parseInt(st.point),
                            0
                          ) +
                          " / " +
                          tmzPointSuccess
                        }}</template>
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </vue-custom-scrollbar>
          </div>
          <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
            <vue-custom-scrollbar
              :style="`height: ${scrollHeight.right}px; position: relative;`"
            >
              <h6 class="tx-uppercase tx-semibold mg-b-5">Ангилал</h6>
              <!-- <nav class="nav nav-classic tx-13 pd-l-5">
                <router-link
                  :to="{ name: $route.name, params: { cid: type.id } }"
                  :class="
                    `nav-link ${$route.params.cid == type.id ? 'active' : ''}`
                  "
                  v-for="(type, i) in types"
                  :key="'st' + i"
                >
                  <span>{{ type.label }}</span>
                </router-link>
              </nav> -->
              <!-- <Cascader @change="cascaderOnChange"
          change-on-select filterable clearable  v-model="cascaderSelected" :options="casTypes" class="wd-100p"></Cascader> -->
              <div class="pd-5">
                <input
                  placeholder="Хайх"
                  v-model="filterText"
                  class="form-control"
                />
              </div>
              <Tree
                ref="folterTree"
                node-key="id"
                node-key1="label"
                :data="folders"
                :props="defaultProps"
                @node-click="categoryChange"
                auto-expand-parent
                accordion
                :expand-on-click-node="true"
                highlight-current
                :current-node-key="$route.params.cid"
                :default-expanded-keys="expandKeys"
                :filter-node-method="filterNode"
                class="manual-tree"
              >
              </Tree>
              <!-- :key="treeKey" -->

              <!-- <CascaderPanel :options="casTypes"></CascaderPanel> -->
              <div class="card mg-t-10">
                <div class="card-body pd-10">
                  <div class="d-flex bd-b mg-b-10">
                    <label
                      class="
                        tx-sans
                        tx-11
                        tx-semibold
                        tx-uppercase
                        tx-color-01
                        tx-spacing-1
                      "
                      >Хайлт</label
                    >
                  </div>
                  <form>
                    <div class="form-group row">
                      <label class="col-sm-12 col-form-label pd-y-0 tx-color-03"
                        >Судалгааны нэр</label
                      >
                      <div class="col-12 pd-y-0">
                        <input
                          type="text"
                          v-model="search.task"
                          placeholder="Судалгааны нэр бичнэ үү"
                          class="form-control ht-30"
                        />
                      </div>
                    </div>
                  </form>
                  <form>
                    <div class="form-group row">
                      <label class="col-sm-12 col-form-label pd-y-0 tx-color-03"
                        >Гүйцэтгэсэн</label
                      >
                      <div class="col-12 pd-y-0">
                        <input
                          type="text"
                          v-model="search.st1"
                          placeholder="Гүйцэтгэсэн хүний нэр бичнэ үү"
                          class="form-control ht-30"
                        />
                      </div>
                    </div>
                  </form>
                  <form>
                    <div class="form-group row">
                      <label class="col-sm-12 col-form-label pd-y-0 tx-color-03"
                        >Он эхлэх</label
                      >
                      <div class="col-12 pd-y-0">
                        <DatePicker v-model="dateSearch" type="year">
                        </DatePicker>
                      </div>
                    </div>
                  </form>
                  <form>
                    <div class="form-group row">
                      <label class="col-sm-12 col-form-label pd-y-0 tx-color-03"
                        >Он дуусах</label
                      >
                      <div class="col-12 pd-y-0">
                        <DatePicker v-model="dateSearchEnd" type="year">
                        </DatePicker>
                      </div>
                    </div>
                  </form>
                  <div class="btn-group">
                    <button
                      @click="getList"
                      class="btn btn-xs btn-outline-light"
                    >
                      Хайх</button
                    ><button
                      class="btn btn-xs btn-outline-light"
                      @click="clearFilter"
                    >
                      Бүгд
                    </button>
                  </div>
                </div>
              </div>

              <go-points class="mg-t-20" :hidePrint="true" />
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>


    <!-- hide-footer -->
    <b-modal
      v-model="modal.show"
      :title="modal.data.task"
      centered
      body-class="pd-0"
      size="xl"
      scrollable
    >
      <div class="modal-body pd-0" v-if="modal.rdy">
        <div v-show="!readable">
          <!-- <button class="btn btn-primary" @click="purchaseBook(modal.data)">
            <feather type="shopping-cart" class="mg-r-5" />Худалдаж авах
          </button> -->
          <div class="text-center">
            <img :src="`${modal.data.secondAttachmentUrl}?w=1200`" />
          </div>
          <div class="pd-l-20 pd-r-20">
            <div v-html="modal.data.taskDesc"></div>
          </div>

          <div class="pd-l-20">
            <div>
              <p class="tx-rubik tx-normal mg-t-auto">
                <b> Гүйцэтгэсэн хүмүүсийн нэрс: {{ modal.data.st1 }} </b>
              </p>
            </div>
          </div>
          <div class="pd-l-20">
            <div>
              <p class="tx-rubik tx-normal mg-t-auto">
                <b> Он: {{ modal.data.dueStartDate | moment("YYYY") }} </b>
              </p>
            </div>
          </div>

          <!-- <div class="pd-20">
            <div>
              <h3 class="tx-rubik tx-normal mg-b-30 mg-t-auto">
                Үнэ: {{ modal.data.budget }}₮
              </h3>
            </div>
          </div> -->
        </div>
        <file-preview
          :id="modal.data.defaultAttachmentId"
          v-show="readable"
          :force="true"
          :minusHeight="200"
          @on-file-loaded="onFileLoaded"
        />
      </div>
      <!-- class="modal-footer pd-x-20 pd-y-15" -->
      <template #modal-footer>
        <div
          v-if="!readable"
          class="d-flex align-items-center justify-content-left wd-100p"
        >
          <div>
           
            <span class="tx-rubik tx-normal" style="font-size: 16px">
              <b> Үнэ: {{ modal.data.budget }}₮ </b>
            </span>
          </div>
          <attach-rating
              v-if="fileInf.ready"
              :fileInf.sync="fileInf"
              class="mg-l-10"
              @on-rate="onRated"
              :allowHalf="false"
              :disabled="true"
            />
          <div class="mg-l-auto">
             
            <button
              type="button"
              class="btn btn-white mg-r-5"
              data-dismiss="modal"
              @click="
                modal.show = false;
                readable = false;
              "
            >
              Болих
            </button>
            <button
              v-if="modal.data.budget > 0 && modal.data.im == null"
              class="btn btn-primary"
              @click="purchaseBook(modal.data)"
            >
              <feather type="shopping-cart" class="mg-r-5" />Худалдаж авах
            </button>
            <button v-else class="btn btn-primary" @click="readable = true">
              <feather type="book-open" class="mg-r-5" />Унших
            </button>
          </div>
        </div>
        <div v-else>
          <attach-rating
            v-if="fileInf.ready"
            :fileInf.sync="fileInf"
            class="mg-l-10"
            @on-rate="onRated"
            :allowHalf="false"
            :disabled="false"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import {
  Notification,
  CascaderPanel,
  Cascader,
  DatePicker,
  Tree,
} from "element-ui";

var LTT = require("list-to-tree");
var _ = require("lodash");

export default {
  components: {
    CascaderPanel,
    Cascader,
    DatePicker,
    Tree,
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    goPoints: () => ({
      component: import("@/views/modules/lms/components/points"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      filterText: "",
      readable: false,
      search: {
        task: "",
      },
      tmzPointSuccess: 0,
      point: {},
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0,
      },
      nowDate: null,
      types: [],
      casVal: null,
      typesFlat: [],
      casTypes: [],
      cascaderSelected: [],
      tasks: [],
      allCount: 0,
      typeKey: "typeresearch",
      ot: 285,
      groupLogo: "",
      modal: {
        id: 0,
        rdy: false,
        show: false,
        data: {},
      },
      canView: false,
      tmzPointSuccess: 0,
      colors: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "indigo",
        "purple",
        "pink",
        "teal",
        "orange",
      ],
      dateSearch: null,
      dateSearchEnd: null,
      folders: [],
      foldersFlat: [],
      defaultProps: {
        children: "children",
        label: "title",
        iid: "id",
      },
      expandKeys: [32780],
      fileInf: {
        ready: false,
        obj: {},
      },
    };
  },
  mounted() {
    // this.toggleBodyClass("addClass", "app-lms");
    // require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    let _companyLogo = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }

    let _pointSuccess = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "tmzPointSuccess"
    );
    if (_pointSuccess.length > 0 && _pointSuccess[0].value != undefined) {
      this.tmzPointSuccess = parseInt(_pointSuccess[0].value, 10);
    }

    //GetMyTMZPoint({ selectedUserId: 0 })
    request({
      api: { method: "get", url: "learn/GetMyTMZPoint" },
      store: this.$store,
    }).then((res) => {
      this.point = res.data;
      //console.log(this.point)
      if (this.$store.state.app.activeGroup.id == 6126) {
        this.canView = true;
        this.init();
      } else {
        if (
          this.point.pointOptions.reduce(
            (sum, st) => sum + parseInt(st.point),
            0
          ) >= this.tmzPointSuccess
        ) {
          this.canView = true;
          this.init();
        }
      }
    });

    //this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    onFileLoaded(e) {
      this.fileInf = {
        obj: e,
        ready: true,
      };
    },
    onRated(e) {
      //console.log(e);
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    categoryChange(e) {
      // this.curId = e.id;
      //let _id = e.id;
      this.casVal = e.id;
      this.getList();
      // this.$router.push({ name: "landingHelp", params: { id: 0, cid: e.id } });
    },
    purchaseBook(order) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/CreateInvoiceByTaskId" },
        store: this.$store,
        data: {
          id: order.id,
          taskDesc: order.task,
        },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$router.push(`/lms/paymentDetail/${res.data.invoiceId}`);
        }
      });
    },
    init() {
      request({
        api: { method: "get", url: "type/getTreeData" },
        params: {
          key: this.typeKey,
          getParentType: false,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log(res);
          let dataTypes = res.data.types;
          this.typesFlat = dataTypes;

          this.types = dataTypes.filter((x) => x.code == "tab");
          //# TODO cascader panel
          var ltt = new LTT(dataTypes, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children",
          });
          //this.casTypes = _.orderBy(ltt.GetTree(), "ord", "asc");
          this.folders = _.orderBy(ltt.GetTree(), "ord", "asc");
          //this.folders = _.orderBy(ltt.GetTree(), "ord", "asc");
          this.foldersFlat = _.orderBy(res.data.types, "ord", "asc");
        }
      });

      this.getList();
    },
    clearFilter() {
      this.search.task = "";
      this.search.st1 = "";
      //this.search.st1="";
      this.casVal = null;
      this.cascaderSelected = [];

      this.dateSearch = null;
      this.dateSearchEnd = null;

      this.getList();
    },
    getList() {
      let _cid = null;
      if (this.casVal > 0) {
        _cid = this.casVal;
      } else if (this.$route.params.cid > 0) {
        _cid = this.$route.params.cid;
      }

      let _d1 = null;
      let _d2 = null;

      if (this.dateSearch != null && this.dateSearch != "") {
        _d1 = new Date(this.dateSearch).getFullYear() + "/01/01";
      }
      if (this.dateSearchEnd != null && this.dateSearchEnd != "") {
        _d2 = new Date(this.dateSearchEnd).getFullYear() + "/12/31";
      }
      //console.log(_d1, _d2);

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 200,
          ot: this.ot,
          model: {
            isPublic: true,
            //isTender: false,
            locTypeId: _cid,
            task: this.search.task,
            st1: this.search.st1,
            dueDateSearchStart: _d1,
            dueDateSearchEnd: _d2,
          },
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log('GetCoreList', res);
          this.allCount = res.data.allCount;
          this.nowDate = res.data.nowDate;
          this.tasks = res.data.tasks;
        }
      });
    },
    taskDetail(id, budget) {
      if (
        this.$store.state.app.activeGroup.id == 6126 &&
        (budget == 0 || budget == null)
      ) {
        if (
          this.point.pointOptions.reduce(
            (sum, st) => sum + parseInt(st.point),
            0
          ) >= this.tmzPointSuccess
        ) {
          this.read(id);
        } else {
          Notification.error({
            message:
              "Үнэ төлбөргүй номыг Үүргийн биелэлт хангасан гишүүн үзэх боломжтой",
            duration: 10000,
            type: "error",
            position: "top-right",
            offset: 50,
          });
        }
      } else {
        this.read(id);
      }
    },
    read(id) {
      this.readable = false;
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.id = id;
          this.modal.data = res.data.task;
          this.modal.show = true;
          this.modal.rdy = true;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },

    cascaderOnChange(value) {
      let _id =
        value[value.length - 1] != undefined ? value[value.length - 1] : null;
      this.casVal = _id;
      this.getList();
      //console.log()
      //this.$router.push({name: this.$route.name, cid: _id});
    },
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.casVal = null;
        this.cascaderSelected = [];
        this.$nextTick(() => {
          this.init();
        });
      }
    },
    filterText(val) {
      this.$refs.folterTree.filter(val);
    },
  },
};
</script>
